const ResultsFilterControls = ({
  filterText,
  onFilterTextChange,
  sortOption,
  sortDirection,
  onSortChange,
  totalFilteredResults,
  paginatedResultsCount,
  displayedFilterText,
  includeImages
}) => {
  return (
    <>
      <div className="results-controls">
        <div className="filter-container">
          <div className="search-box">
            <i className='bx bx-search'></i>
            <input
              type="text"
              placeholder="Filter results by brand name, active substance or EU number..."
              value={filterText}
              onChange={(e) => onFilterTextChange(e.target.value)}
              className="filter-input"
            />
            {filterText && (
              <button className="clear-filter" onClick={() => onFilterTextChange('')}>
                <i className='bx bx-x'></i>
              </button>
            )}
          </div>
        </div>
        <div className="sort-container">
          <span className="sort-label">Sort by:</span>
          <div className="sort-buttons">
            <button className={`sort-button ${sortOption === 'euNumber' ? 'active' : ''}`} onClick={() => onSortChange('euNumber')}>
              EU number{sortOption === 'euNumber' && (<i className={`bx ${sortDirection === 'asc' ? 'bx-sort-up' : 'bx-sort-down'}`}></i>)}
            </button>
            <button className={`sort-button ${sortOption === 'name' ? 'active' : ''}`} onClick={() => onSortChange('name')}>
              Brand name{sortOption === 'name' && (<i className={`bx ${sortDirection === 'asc' ? 'bx-sort-up' : 'bx-sort-down'}`}></i>)}
            </button>
            <button className={`sort-button ${sortOption === 'activeSubstance' ? 'active' : ''}`} onClick={() => onSortChange('activeSubstance')}>
              Active substance{sortOption === 'activeSubstance' && (<i className={`bx ${sortDirection === 'asc' ? 'bx-sort-up' : 'bx-sort-down'}`}></i>)}
            </button>
            <button className={`sort-button ${sortOption === 'hits' ? 'active' : ''}`} onClick={() => onSortChange('hits')}>
              📄Document count{sortOption === 'hits' && (<i className={`bx ${sortDirection === 'asc' ? 'bx-sort-up' : 'bx-sort-down'}`}></i>)}
            </button>
            {includeImages && (
              <button className={`sort-button ${sortOption === 'imageCount' ? 'active' : ''}`} onClick={() => onSortChange('imageCount')}>
                📷Image count{sortOption === 'imageCount' && (<i className={`bx ${sortDirection === 'asc' ? 'bx-sort-up' : 'bx-sort-down'}`}></i>)}
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="filtered-results-info">
        Showing {paginatedResultsCount} of {totalFilteredResults} medicines
        {displayedFilterText && (<span> filtered by "{displayedFilterText}"</span>)}
      </div>
    </>
  );
};

export default ResultsFilterControls;